import React from 'react';

import Layout from '../components/Layout';

// import { Link } from 'gatsby';
import Sidebar from '../components/Sidebar';
import config from '../../config';
import avatar from '../assets/images/jason-long-avatar.jpeg';


const IndexPage = () => (
  <Layout>
    <Sidebar />
    <div className="container-fluid p-0">
      <section
        className="resume-section p-3 p-lg-5 d-flex align-items-center"
        id="about"
      >
        <div className="w-100">
          <img
            className="img-fluid img-profile rounded-circle mx-auto mb-5 d-block d-sm-none"
            src={avatar}
            alt="Jason Long - Headshot"
          />
          <h1 className="mb-0 nameHeader text-break">
            {config.firstName}&nbsp;
            <span className="text-primary text-nowrap">{config.lastName}</span>
          </h1>
          <div className="subheading mb-5">
            <span className="d-block d-md-inline text-nowrap">{config.address}</span><span className="d-none d-md-inline">&nbsp;&bull;&nbsp;</span><span className="d-block d-md-inline text-nowrap">{config.phone}</span><span className="d-none d-md-inline">&nbsp;&bull;&nbsp;</span>
            <span className="d-block d-md-inline"><a href={`mailto:${config.email}`}>{config.email}</a></span>
          </div>
          <p className="lead mb-5">
            {config.introParagraph}
          </p>
          <div className="social-icons">
            {config.socialLinks.map(social => {
              const { icon, url, name } = social;
              return (
                <a key={url} href={url} title={name}>
                  <i className={`fab ${icon}`}></i>
                </a>
              );
            })}
          </div>
        </div>
      </section>

      <hr className="m-0" />

      <section
        className="resume-section p-3 p-lg-5 d-flex justify-content-center"
        id="experience"
      >
        <div className="w-100">
          <h2 className="mb-5">Experience</h2>
          {config.experience.map((experience, index) => {
            const { jobTitle, promotedFrom, companyName, companyLink, description, timeFrameBegin, timeFrameEnd } = experience;
            return (
              <div className="resume-item d-flex flex-column flex-md-row justify-content-between mb-5" key={index}>
                <div className="resume-content">
                  <h3 className="mb-0">{jobTitle} {promotedFrom ? <small className="text-muted d-block">(Previous: {promotedFrom})</small> : ''}
                  </h3>
                  <div className="subheading mb-3"><a key={companyLink} href={companyLink}>{companyName}</a></div>
                  <div dangerouslySetInnerHTML={{ __html: description }} />
                </div>
                <div className="resume-date text-md-right">
                  <span className="text-primary">{timeFrameBegin} &ndash; {timeFrameEnd}</span>
                </div>
              </div>
            );
          })}
          <p>Additonal experience details can be found on <a href="https://linkedin.com/in/jasonmlong/">LinkedIn</a>.</p>
        </div>
      </section>
      <hr className="m-0" />

      <section
        className="resume-section p-3 p-lg-5 d-flex align-items-center"
        id="education"
      >
        <div className="w-100">
          <h2 className="mb-5">Education</h2>
          {config.education.map((education, index) => {
            const { schoolName, degree, gpa, description, timeFrameBegin, timeFrameEnd } = education;
            return (

              <div className="resume-item d-flex flex-column flex-md-row justify-content-between mb-5" key={index}>
                <div className="resume-content">
                  <h3 className="mb-0">{schoolName}</h3>
                  <div className="subheading mb-3">{degree}</div>
                  <p>GPA: {gpa}</p>
                  <div dangerouslySetInnerHTML={{ __html: description }} />
                </div>
                <div className="resume-date text-md-right">
                  <span className="text-primary">{timeFrameBegin} &ndash; {timeFrameEnd}</span>
                </div>
              </div>
            );
          })}

        </div>
      </section>

      <hr className="m-0" />

      <section
        className="resume-section p-3 p-lg-5 d-flex align-items-center"
        id="skills"
      >
        <div className="w-100">
          <h2 className="mb-5">Skills</h2>

          <div dangerouslySetInnerHTML={{ __html: config.skills }} />

        </div>
      </section>

      <hr className="m-0" />

      <section
        className="resume-section p-3 p-lg-5 d-flex align-items-center"
        id="interests"
      >
        <div className="w-100">
          <h2 className="mb-5">Interests</h2>
          <div dangerouslySetInnerHTML={{ __html: config.interests }} />
        </div>
      </section>

      <hr className="m-0" />

      <div className="w-100 colophon">
        <div className="p-3 p-lg-5" dangerouslySetInnerHTML={{ __html: config.colophon }} />
      </div>

    </div>
  </Layout>
);

export default IndexPage;
